var animationDurationVar = 'var(--animationDurationVar__1mjtb9o1)';
var animationNameVar = 'var(--animationNameVar__1mjtb9o0)';
var animationTimingFunctionVar = 'var(--animationTimingFunctionVar__1mjtb9o2)';
var root = 'animationController_root__1mjtb9o3';

export { animationDurationVar, animationNameVar, animationTimingFunctionVar, root };
//# sourceMappingURL=animationController.vanilla.mjs.map
